'use client';

import { FC } from 'react';
import { ErrorFallbackProps } from './ErrorFallback.types';
import { Flex, ButtonGroup, Button, Alert } from '@/_components';

export const ErrorFallback: FC<ErrorFallbackProps> = () => {
  const onRefresh = () => {
    window.location.href = '/';
  };

  return (
    <Flex isColumn={true} padding={6} isCentered={true} gap={4}>
      <Alert type="danger" icon="warning-outline">
        <Flex isColumn={true} gap={8}>
          <span>
            Something went wrong. Please refresh this page to try again.
          </span>
          <ButtonGroup align="center">
            <Button
              value="Refresh Soraban"
              iconLeft="refresh"
              intent="danger"
              onClick={onRefresh}
            />
          </ButtonGroup>
        </Flex>
      </Alert>
    </Flex>
  );
};
